/**
 * Main App Component
 * Router setup and global layout
 */

import React from 'react'
import { Dashboard } from './components/Dashboard'

export function App() {
  return (
    <div className="App">
      <Dashboard />
    </div>
  )
}

export default App
